"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const flatAppUser_1 = __importDefault(require("../shared/flatAppUser"));
const clientAppOnAuthenticated = async ({ projectId, appId, optionalUserValues, processor, }) => {
    const { currentUser } = processor.root.firebase.auth();
    if (!currentUser) {
        throw new Error('User is not loged');
    }
    const flatedUser = (0, flatAppUser_1.default)(currentUser);
    if (!flatedUser.email) {
        throw new Error('User has no email');
    }
    await processor.root.cloud.saveMemberData({
        email: flatedUser.email,
        name: (optionalUserValues === null || optionalUserValues === void 0 ? void 0 : optionalUserValues.name) || flatedUser.displayName || 'User name',
        phone: (optionalUserValues === null || optionalUserValues === void 0 ? void 0 : optionalUserValues.phone) || flatedUser.phoneNumber || null,
        projectId,
        appId,
        uid: currentUser.uid,
    });
    await processor.root.loadFirebaseUserInfo();
};
exports.default = clientAppOnAuthenticated;
